const items = [
  {
    title: '503A Compounding Pharmacies',
    sub: 'Patient-specific, FDA-regulated',
    tone: 'bg-teal-600',
    icon: (
      <svg className="h-[19px] w-[19px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M3 21h18M5 21V7l7-4 7 4v14" />
        <path d="M9 21v-5h6v5" />
      </svg>
    ),
  },
  {
    title: 'Prescription-Only Care',
    sub: 'Licensed U.S. pharmacies only',
    tone: 'bg-plum-600',
    icon: (
      <svg className="h-[19px] w-[19px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M6 20V5a1 1 0 0 1 1-1h6a4 4 0 0 1 0 8H6M11 12l6 8" />
      </svg>
    ),
  },
  {
    title: 'Licensed Practitioners Only',
    sub: 'Every prescription, every time',
    tone: 'bg-leaf-500',
    icon: (
      <svg className="h-[19px] w-[19px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M16 11a4 4 0 1 0-8 0M4 20a8 8 0 0 1 16 0" />
      </svg>
    ),
  },
  {
    title: 'Licensed in All 50 States',
    sub: 'Nationwide telehealth',
    tone: 'bg-teal-300',
    icon: (
      <svg className="h-[19px] w-[19px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="9" />
        <path d="M3.5 9h17M3.5 15h17M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18" />
      </svg>
    ),
  },
  {
    title: 'HIPAA-Aligned Care',
    sub: 'Private & secure workflows',
    tone: 'bg-teal-700',
    icon: (
      <svg className="h-[19px] w-[19px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6z" />
        <path d="m9 12 2 2 4-4" />
      </svg>
    ),
  },
]

export function CredBar() {
  return (
    <section className="bg-[#191A17] px-5 py-[22px] sm:px-6 lg:px-8">
      <div className="flex flex-col gap-3.5 lg:flex-row lg:flex-wrap lg:items-center lg:justify-between lg:gap-5">
        {items.map((item, i) => (
          <div key={item.title} className="flex w-full items-center gap-[11px] lg:w-auto">
            {i > 0 && (
              <span
                aria-hidden
                className="mr-2 hidden h-[34px] w-px shrink-0 bg-white/15 lg:block"
              />
            )}
            <span
              className={`flex h-[38px] w-[38px] shrink-0 items-center justify-center rounded-full text-white ${item.tone}`}
            >
              {item.icon}
            </span>
            <div className="min-w-0">
              <div className="font-display text-[13px] font-extrabold leading-[1.25] text-white">
                {item.title}
              </div>
              <div className="text-[11px] font-normal text-white/55">{item.sub}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
